module.exports = __webpack_public_path__ + "img/solution4.1b173ba0.png";